<template>
  <Popup :model-value="showPopup" popup-header="Success" custom-classes="overflow-visible" @close="closePopup">
    <div class="relative">
      <p class="text-body mb-16">
        Your Adventure can now be viewed by parents. Look out for new messages and get ready to have fun!
      </p>
      <p class="text-body mb-16">You will now be redirected to your Adventures dashboard.</p>
      <Confetti
        class="absolute pointer-events-none overflow"
        style="width: calc(100% + 300px); height: calc(100% + 300px); left: -150px; top: -150px"
      />
      <Button value="OK" size="medium" class="w-full" @click.prevent="closePopup" />
    </div>
  </Popup>
</template>

<script lang="ts">
import Popup from '../../../../components/popup/Popup.vue';
import Button from '../../../../components/button/Button.vue';
import Confetti from '@/components/confetti/Confetti.vue';

export default {
  name: 'ReviewSuccess',
  components: { Popup, Button, Confetti },
  props: {
    showPopup: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    closePopup(): any {
      this.$emit('close');
      this.$router.push({ path: '/adventures' });
    },
  },
};
</script>
